import * as S from './styles'
import ReactPaginate from 'react-paginate'
import { GetOrdersRequest, GetOrdersResponse } from '../../types/pedidos'
import { GetNegociacaoRequest } from '../../types/negociacao'

interface PaginationProps {
  setFilterParams: (
    previousState: (
      value: GetOrdersRequest | GetNegociacaoRequest
    ) => GetOrdersRequest | GetNegociacaoRequest
  ) => void
  data: GetOrdersResponse
}

const Paginator = ({ setFilterParams, data }: any) => {
  const handleClick = ({ selected }) => {
    setFilterParams((prev) => ({ ...prev, Page: selected + 1 }))

    return window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
  return (
    <>
      {data?.TotalPages > 1 && (
        <S.Wrapper>
          <ReactPaginate
            pageCount={data?.TotalPages}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handleClick}
            previousLabel={''}
            nextLabel={''}
            containerClassName={'pagination-container'}
            disabledClassName={'pagination-disabled'}
            activeClassName={'pagination-active'}
            previousClassName={'prev'}
            nextClassName={'next'}
            forcePage={data && data.PageNumber - 1}
          ></ReactPaginate>
        </S.Wrapper>
      )}
    </>
  )
}

export default Paginator
